import { ModalContent as Content } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import breakpoints from '@theme/foundations/breakpoints';
const ModalContent = styled(Content) `
  background: #FFFFFF;
  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.20);
  overflow: hidden;
  padding: 16px;
  margin-top: auto;
  margin-bottom: auto;
  ${({ modalwidth }) => (modalwidth ? css `width: ${modalwidth};` : css ``)}
  ${({ modalheight }) => (modalheight ? css `height: ${modalheight};` : css ``)}
  ${({ borderRadius }) => css `border-radius: ${borderRadius !== null && borderRadius !== void 0 ? borderRadius : '16px'};`}
  max-height: calc(100% - 150px);
  max-width: calc(100% - 120px);
  
  @media screen and (max-width: ${breakpoints.sm}) {
    margin-top: unset;
    margin-bottom: unset;
    max-height: 100%;
    width: 100%;
    min-width: 100%;
    align-self: end;
  }
`;
export const Styled = {
    ModalContent,
};
